<div *ngIf="loading" class="loader-container flex flex-col items-center justify-center">
    <ngx-loading *ngIf="!progression" [show]="loading" [config]="config"></ngx-loading>
    <div class="w-full" *ngIf="progression">
        <h1>{{ progression.activity || 'Processing' }}...</h1>
        <mat-progress-bar [mode]="select_mode" value="{{ progression.value * 100 }}"></mat-progress-bar>
    </div>
</div>